export default {"src":"/_next/static/media/fb.f1e90f72.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};